export default __webpack_public_path__ + "static/media/falda-larga-mujer.869deedf.png";